import { useCallback, useContext, useRef, useMemo, useEffect } from 'react';

import { isEmpty } from 'ramda';

import { LANDING_PAGE_ROLES } from 'constants/index';
import { getDateFormat } from 'utils/date';

import { PDFDataContext } from '../../context';
import { useRecursive } from '../../functions';

export function useRelocationsPage({ onReady }) {
  const { page } = useContext(PDFDataContext);
  const pageJSON = useMemo(() => page.landing.pages.find((p) => p.role === LANDING_PAGE_ROLES.RELOCATIONS), [page]);
  const collection = useMemo(() => page?.relocations || [], [page?.relocations]);
  const showCondition = isEmpty(collection) || !pageJSON || pageJSON.hidden;
  const dateFormat = getDateFormat(page?.settings?.displayDatesDdMmYyyy);

  const wasFailureRef = useRef(false);
  const handleMainReadyHandler = useCallback(() => {
    if (!wasFailureRef.current) {
      onReady();
    }
  }, [onReady]);

  const { innerPages, handleReady, handleFail, helper } = useRecursive({
    items: collection,
    onReady: handleMainReadyHandler,
  });

  const handleFailureHandler = useCallback(
    (blocks) => {
      if (blocks.length === 1) {
        wasFailureRef.current = true;
        helper.dropLastPage();
      }

      handleFail();
    },
    [handleFail, helper],
  );

  useEffect(() => {
    if (showCondition) {
      onReady();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collection]);

  return {
    innerPages,
    handleFailureHandler,
    handleReady,
    showCondition,
    dateFormat,
  };
}
